import { useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { DownloadOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import TurnOver from '../../dashboard/component/turnover';
import BusinessFilter from '../../../common/filter/businessFilter';
import CardMetrics from '../../../common/card/cardMetric';
import PaymentsHistorySolde from '../../payements/component/paymentsHistorySolde';
import { getMetricsByMerchandId } from '../../developer/services/developerApi';
import { useQuery } from 'react-query';

const Solde = ({ showButton = true, showCard = true }) => {
  document.title = `Soldes | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [amount, setAmount] = useState(0);

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const merchandId = currentUser?.user?.id || currentUser?.user?.merchantId;
  
  const {
      data: metrics,
      isLoading: isLoadingMetric,
      isError: isErrorMetric,
      error: errorMetric,
    } = useQuery(
      ["metrics", merchandId],
      () => getMetricsByMerchandId(merchandId),
      { enabled: !!merchandId }
  );
  
  return (
    <div>
      {showButton && (<div className='title-page mb-2 mt-4'>Soldes</div>)}      
      <div className='mb-4 mt-4'>
        <BusinessFilter onFilter={({ business, year }) => {setSelectedBusiness(business); setSelectedYear(year);}}/>
      </div>

      {showCard && 
        <CardMetrics data={selectedBusiness?.id !== "all" ? selectedBusiness : metrics } turnOver= {amount} />
      }
      
      {/* {showButton && (
        <Link to="/versement"><Button className='btn-ask-versement mb-4 mt-2'><DownloadOutlined /> Demander un versement</Button></Link>
      )} */}

      <Row className='mb-4'>
        <Col lg={12}>
          <PaymentsHistorySolde busId={selectedBusiness?.id} customTitle =""/>
        </Col>
      </Row>

      {showButton && (
        <Row>
          <Col lg={12}>
            <TurnOver title="Evolution de mon solde" selectedBusiness={selectedBusiness} setAmountForHome={setAmount} />
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Solde;
